import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import style from './BackArrow.module.scss';

class BackArrow extends Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    theme: PropTypes.string
  };

  static defaultProps = {
    width: 22,
    height: 13,
    theme: 'White',
  };

  render() {
    const { width, height, className, theme } = this.props;
    const arrowClasses = classNames(style.BackArrow, className, style[`${theme}`], {});

    return (
      <svg className={arrowClasses} width={width} height={height} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" stroke="currentColor" className={style.svgGroup} fillRule="evenodd">
          <path d="M1 6h21" fill="#FFF" fillRule="nonzero" />
          <path d="M7 0L1 6l6 6" />
        </g>
      </svg>
    );
  }
}

export default BackArrow;



// WEBPACK FOOTER //
// ./src/components/Icons/BackArrow.js